export default __webpack_public_path__ + "static/3-6492380767b31d904c7a5b24266a6b67.png";